import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-gold-soft/50 ${className}`} aria-hidden="true" data-id="element-126" data-mp="1zbqyo7zazzuw">
      <Icon className="h-6 w-6 text-gold-ink" strokeWidth={1.4} data-id="element-127" data-mp="249aevdfkamph" />
    </span>;
}